function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import TabsComponent from "components/core/tabs/tabs-component";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import TwoThirdsTextAndAssetComponentDefaultProps from "segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/default-props";
export default _object_spread_props(_object_spread({}, TabsComponent.defaultProps), {
    tabsColor: WORK_OS_IRIS_COLOR_NAME,
    tabs: [
        {
            tabLabel: "Clients Projects",
            textAndAsset: _object_spread_props(_object_spread({}, TwoThirdsTextAndAssetComponentDefaultProps), {
                fullParagraph: _object_spread_props(_object_spread({}, TwoThirdsTextAndAssetComponentDefaultProps.fullParagraph), {
                    topic: {},
                    title: "Accurately estimate costs and increase profitability",
                    body: "Use Time Tracking to bill clients more accurately. Gain more confidence in estimating future costs."
                }),
                asset: _object_spread_props(_object_spread({}, TwoThirdsTextAndAssetComponentDefaultProps.asset), {
                    position: "center"
                })
            })
        },
        {
            tabLabel: "Content Planning",
            textAndAsset: _object_spread_props(_object_spread({}, TwoThirdsTextAndAssetComponentDefaultProps), {
                fullParagraph: _object_spread_props(_object_spread({}, TwoThirdsTextAndAssetComponentDefaultProps.fullParagraph), {
                    topic: {},
                    title: "Plan your content in advance for maximum productivity",
                    body: "Organize all your content pieces by channel and publish date. Easily assign writers, designers, and editors to every post."
                }),
                asset: _object_spread_props(_object_spread({}, TwoThirdsTextAndAssetComponentDefaultProps.asset), {
                    position: "center"
                })
            })
        }
    ],
    paddingTop: "64px"
});
